module.exports = __webpack_public_path__ + "h5/img/noGood.70ac1689.png";